export const initialValues = {
  values: {
    account: null,
    charge: "",
    payment: "",
    concept: "",
  },
  required: {
    account: { required: true },
    charge: { required: true },
    payment: { required: true },
  },
};
